import React from 'react';
import PropTypes from 'prop-types';
import AdvanceTableWrapper from "../../../components/common/advance-table/AdvanceTableWrapper";
import {useUser} from "../../../hooks/useUser";
import {Card} from "react-bootstrap";
import CardTableHeader from "../../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../../components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../../../components/common/advance-table/AdvanceTablePagination";
import NewContractTermModal from "./NewContractTermModal";
import EditContractTermModal from "./EditContractTermModal";
import {useFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import DeleteContractTermModal from "./DeleteContractTermModal";
import {useTableModals} from "../../../hooks/useTableModals";
import DeleteModal from "../../../components/common/modals/DeleteModal";

const defaultColumns = [{
        accessor: 'type.description',
        Header: "Term Type",
    },
    {
        accessor: 'value',
        Header: "Value"
    }]

const ContractTerms = ({terms, contractId, possibleTermTypes}) => {
    const mutation = graphql`
    mutation ContractTermsDeleteMutation( $id: ID!) {
        deleteNode(input: {id: $id}) {
            deletedNodeId @deleteRecord
            owner {
                ... on LegalContract {
                    terms {
                        ...ContractTerms_Terms
                    }
                }
            }
        }
    }`
    const data = useFragment(graphql`
        fragment ContractTerms_Terms on LegalContractTerm @relay(plural: true) {
            id
            type {
                id
                description
                valueType
            }
            value
        }
    `, terms)
    const {hasPermission} = useUser();
    const {selected, newModal, editModal, deleteModal, columns} = useTableModals(defaultColumns, "LegalContractTerm.Update", "LegalContractTerm.Delete");
    
    const availTermTypes = possibleTermTypes.filter(tt => !data.some(x => x.type.id === tt.id))

    return (
        <>
            <AdvanceTableWrapper columns={columns} 
                                 data={data} 
                                 sortable 
                                 pagination 
                                 perPage={10}
            >
                <Card className="mb-3">
                    <Card.Header>
                        <CardTableHeader onNewClick={newModal.onClick}
                                         title={"Contract Terms"}
                                         table
                                         showNew={hasPermission("LegalContractTerm.Create") && availTermTypes.length > 0}
                        />
                    </Card.Header>
                    <Card.Body className="p-0">
                        <AdvanceTable table
                                      headerClassName="bg-200 text-900 text-nowrap align-middle"
                                      rowClassName="align-middle white-space-nowrap"
                                      tableProps={{
                                          size: 'sm',
                                          striped: true,
                                          className: 'fs--1 mb-0 overflow-hidden'}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTablePagination table/>
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <NewContractTermModal contractId={contractId} 
                                  possibleTermTypes={availTermTypes} 
                                  showModal={newModal.showModal} 
                                  onClose={newModal.onClose} 
            />
            {selected && <EditContractTermModal showModal={editModal.showModal} 
                                   onClose={editModal.onClose} 
                                   selectedTerm={selected} 
                                   possibleTermTypes={possibleTermTypes}
            />}
            {selected && <DeleteModal showModal={deleteModal.showModal} 
                                      onClose={deleteModal.onClose} 
                                      id={selected?.id}
                                      mutation={mutation}
                                      thingToDelete={"Term"}
                                     
            >
                <p>This action cannot be undone.</p>
            </DeleteModal>}
        </>
    )
}
ContractTerms.propTypes = {    
    terms: PropTypes.array.isRequired,
    contractId: PropTypes.string.isRequired,
    possibleTermTypes: PropTypes.array.isRequired
}
export default ContractTerms